import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Sample } from "@core/data";
import { Subject } from "rxjs";

@Component({
    selector: 'pv-sample-card',
    templateUrl: 'sample-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'pv-sample-card'
    }
})
export class SampleCardComponent implements OnInit, OnDestroy {

    @Input()
    sample: Sample;

    @Input()
    isActive: boolean = false;

    isTitleOverflowing = false;

    private _destroy$ = new Subject();

    checkTitleOverflow(event: MouseEvent) {
        const el = event.currentTarget as HTMLElement;
        this.isTitleOverflowing = el.scrollWidth > el.clientWidth;
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
        this._destroy$.complete();
        this._destroy$.next();
    }

    showClass(type: string): boolean {
        if (this.isActive && type == this.sample.type) return true;
        return false;
    }
}